<template>
  <div
    :class="brandingClass"
    class="social-group"
  >
    <content-creator
      :settings="getBlobContents('footer-social-icons')"
      :permissions="contentCreatorPermissions"
      :is-visible="editContentCreator"
      :filestore="fileStore"
      name="footer-social-icons"
      allowed-widgets="social-icons"
      @updateBlob="(data) => saveBlob('footer-social-icons', data)"
    />
  </div>
</template>

<script>
import applogger from '@applogger'
import contentCreatorMixin from 'src/app/content-creator-mixin'

export default {
  name: 'page-element-social-links',
  mixins: [
    contentCreatorMixin
  ],
  asyncData({store}) {
    const __loader = () => {
      applogger.debug('page-element-social-links asyncData start')
      let blobsToLoad = {
        'footer-social-icons': {}
      }
      let prefetchContent = Object.keys(blobsToLoad).map(name => {
        return store.dispatch('blob/load', { blobID: name, cacheOptions: { ...blobsToLoad[name], scope: 'global', ttl: 3600 * 12 } })
      })
      return Promise.all(prefetchContent)
        .then(_ => {
          applogger.debug('page-element-social-links asyncData complete')
        })
    }
    return store.dispatch('promisePool', {
      name: `page-element-social-links`,
      resolve: __loader
    })
  },
  props: {
    'socialBranding': {
      type: Boolean,
      required: false,
      default: true
    },
    'socialAlignment': {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      filestoreName: 'website'
    }
  },
  computed: {
    brandingClass() {
      if (this.socialBranding === true) {
        return 'branded ' + this.socialAlignment
      }
      else {
        return this.socialAlignment
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@scss/custom.scss";

  $social-icon-size: 1em;
  $social-icon-color: $white;
  $social-icon-border-color: rgba(255, 255, 255, 0.25);
  $footer-link: $white;

  //alignment props
  // align-right, aligns all social items right aligned with a single row on desktop devices
  // align-left, aligns all social items left aligned with a single row on desktop devices
  // align-vertical vertical column based alignment for use in a cta region on a footer

  //define positioning
  .social-group {

    //center alignment
    &.align-center {
      justify-content: center;
      .social-list-item {
        margin:0em .35em;
        @include media-breakpoint-up(sm) {
          .social-list-item {
            margin: 0em 0.5em;
          }
        }
      }
    }
    //left and right padding specific to left / right alignment
    &.align-left,
    &.align-right {
      justify-content: center;
      @include media-breakpoint-down(sm) {
        .social-list-item {
          margin: 0em 0.35em;
        }
      }
      //allow for more spacing on larger phones / tablets
      @include media-breakpoint-up(sm) {
        .social-list-item {
          margin: 0em 0.5em;
        }
      }
    }
    //specific to right alignment for desktop browsers
    @include media-breakpoint-up(lg) {
      &.align-right {
        justify-content: flex-end;
        flex-grow: 1;
        .social-list {
          margin-left: 1em;
        }
        .social-list-item {
          margin: 0em 0em 0em 1em;
        }
      }
      //specific to left alignment for desktop browsers
      &.align-left {
        justify-content: flex-start;
        .social-list-item {
          margin: 0em 1em 0em 0em;
        }
      }
    }
    //vertical alignment settings
    &.align-vertical {
      .social-list {
        display: flex;
        flex-direction: column;
      }
      .social-link {
        display: flex;
      }
      .social-list-item {
        margin-bottom: 1em;
        display: flex;
      }
      //present the social label for vertical option
      .social-label {
        display: flex;
        align-items: center;
        padding-left: 1em;
      }
    }
  }
  //define structure
  .social-group {
    display: flex;
    .social-list {
      display: flex;
      flex-direction: row;
    }
    .social-link {
      display: flex;
    }
    .social-icon {
      box-sizing: content-box;
      height: 1em;
      width: 1em;
      padding: 0.75em;
      margin: 0em auto;
      text-align: center;
      line-height: inherit;
      position: relative;
      display: flex;
    }
    .icon {
      display: flex;
      width: 1em;
      height: 1em;
    }
    .social-label {
      display: none;
    }
  }

  //define theming, icon sizing for the social items
  .social-icon {
    border: 1px solid;
    border-color: $social-icon-border-color;
    border-radius: 100%;
    @include transition (background-color .3s, border-color .3s);
    font-size: $social-icon-size;
  }
  .social-link {
    //will increase both the lable and icon sizig
    color: $social-icon-color;

    .social-icon {
      .icon {
        @include transition (transform .3s);
      }
    }
    @include hover-focus {
      .social-icon {
        background-color: $social-icon-color;
      }
      .icon {
        color: $primary;
      }
    }
  }

  //define a mixin for brand colours, if chosen

  @mixin social-icon($color) {
    @include hover-focus {
      .social-icon {
        border-color: lighten($color, 15%);
        background-color: lighten($color, 15%);
      }
      .icon {
        color:$white;
      }
    }
    .social-icon {
      border-color: $color;
      background-color: $color;
    }
    .icon {
      color: $white;
    }
  }
  .social-group {
    &.branded {
      .social-list {
        .facebook {
          // @include social-icon($facebook-brand-color);
        }
        .twitter {
          // @include social-icon($twitter-brand-color);
        }
        .linkedin {
          // @include social-icon($linkedin-brand-color);
        }
        .youtube {
          // @include social-icon($youtube-brand-color);
        }
        .instagram {
          // @include social-icon($instagram-brand-color);
        }
        .google-plus {
          // @include social-icon($google-plus-brand-color);
        }
      }
    }
  }
</style>
